import Image from 'next/image';
import * as styles from './reviews.styles';

export function RedditLockup() {
  return (
    <Image className={styles.redditLockup} width={86} height={24} src="/images/reviews/reddit-logo.svg" alt="Reddit" />
  );
}
